import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    info,
    infoMsg,
    MAX_NAME,
    REQUIRED,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {tagService} from "../../../jwt/_services/clasificator/tagService";
import Switch from "react-bootstrap-switch";
import TagLangs from "./_langs";
import {langTagService} from "../../../jwt/_services/relations/langTagService";
import {utilHelper} from "../../../jwt/_helpers";
import * as Yup from "yup";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";


export default function TagForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [status, setStatus] = useState(editMode ? props.item?.status : false);
    const [langChilds, setLangChilds] = useState([]);
    const [resultArray, setResultArray] = useState([]);
    const [childChanges, setChildChanges] = useState(false);
    const [loading, setLoading] = useState(false);
    const refLangs = useRef(null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }


    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            code: savedData?.code,
            icon: savedData?.icon,
            colorHex: savedData?.colorHex
        }
    });

    const handleSwitchChange = () => {
        setStatus(!status);
    }

    const onSubmit = (data, _) => {
        setLoading(true);

        let dataRequest = {
            uid: data.uid,
            code: data.code,
            icon: data.icon,
            status: status,
            colorHex: data.colorHex,
            colorRgb: utilHelper.hexToRGB(data.colorHex),
            langChilds: langChilds,
        };

        if (!editMode) {
            //Save
            return tagService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    if (childChanges) {
                        saveChilds(resultData.id);
                    }
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;

            if (JSON.stringify(savedData) === JSON.stringify(dataRequest))
                return showToastCustom(info, infoMsg);

            dataRequest = { ...dataRequest, id }

            return tagService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    if (childChanges) {
                        saveChilds(resultData.id);
                    }
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const saveChilds = (id) => {
        // Primero se construye el dataRequest
        let dataRequest = [];
        if (resultArray.length == 0) { // Empty Array
            langChilds.map((langTag) => {
                const data = {
                    id: langTag.id,
                    lang: langTag.lang,
                    tag: {id: id},
                    name: langTag.name,
                };
                dataRequest.push(data);
            });
        }else {
            resultArray.map((langTag) => {
                //Buscar el nombre que se acaba de modificar
                const langIndex = langChilds.findIndex(n => n.lang.id === langTag.lang.id);
                let langChildsA = langChilds.slice();
                const data = {
                    id: langTag.id,
                    lang: langTag.lang,
                    tag: {id: id},
                    name: langChildsA[langIndex].name,
                };
                dataRequest.push(data);
            });
        }

        // Guardamos o actualizamos el arreglo
        if (!editMode) {
            langTagService.saveAll(dataRequest).then(resultData => {
                setResultArray(resultData);
                setLoading(false);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        } else {
            langTagService.updateAll(dataRequest).then(resultData => {
                setResultArray(resultData);
                setLoading(false);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        }
        setLoading(false);
    }

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
        refLangs.current.changeDisabledInput(true);
    }

    const resetForm = () => {
        setSavedData(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        setChildChanges(false);
        refLangs.current.resetForm();
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        setChildChanges(false);
        refLangs.current.changeDisabledInput(false);
    }

    const updateLangChilds = (langChildsP) => {
        if (langChildsP !== undefined) {
            setChildChanges(true);
            setLangChilds(langChildsP);
        }
    }

    const setForm = () => {
        props.setForm();
    }


    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <FormGroup>
                                    <Label>UID Firebase</Label>
                                    <Input type="id" name="uid" id="uid"
                                           disabled
                                           value={editMode ? savedData?.uid : ''}
                                    />
                                </FormGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Icono</Label>
                                <Input type="text" name="icon"
                                       placeholder="Icono"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Color</Label>
                                <br/>
                                <Input type="color" name="colorHex"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={handleSwitchChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        Información internacional
                    </CardTitle>
                    <CardBody>
                        <TagLangs
                            ref={refLangs}
                            tag={{id: savedData?.id}}
                            setForm={setForm}
                            updateItem={updateLangChilds}
                            key={"TagLangId"}
                            editMode={editMode}
                            disableInputs={disableInputs}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}